import { render } from "./tongueInterpretation.vue?vue&type=template&id=38e64371&scoped=true"
import script from "./tongueInterpretation.vue?vue&type=script&lang=js"
export * from "./tongueInterpretation.vue?vue&type=script&lang=js"

import "./tongueInterpretation.vue?vue&type=style&index=0&id=38e64371&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e64371"]])

export default __exports__